import { render, staticRenderFns } from "./CaptureCommentView.vue?vue&type=template&id=79e61bb7&"
import script from "./CaptureCommentView.vue?vue&type=script&lang=js&"
export * from "./CaptureCommentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports